module.exports = __webpack_public_path__ + "static/media/education.3eb61dcf.png";